export default "__VITE_ASSET__f72d31b1__"